<script lang="ts">
  import { CircleAlert, LogOut, RefreshCw, WifiOff } from "@lucide/svelte";
  import type { Mode, Skin, UserSummary } from "../model";
  import MeetingRadar from "./MeetingRadar.svelte";

  let { state, now, mode, skin, user, canConfigure = true, onSignIn, onSignOut, onConfigure, onRetry, onModeChange, onSkinChange }: {
    state: "loading" | "sign-in" | "unsupported" | "unconfigured" | "offline" | "error"; now: Date; mode: Mode; skin: Skin; user?: UserSummary;
    canConfigure?: boolean;
    onSignIn?: () => void; onSignOut?: () => void; onConfigure?: () => void; onRetry?: () => void; onModeChange?: (mode: Mode) => void; onSkinChange?: (skin: Skin) => void;
  } = $props();
</script>

<main class="product-screen auth-product" data-mode={mode}>
  <div class="auth-shell">
    <MeetingRadar meetings={[]} {now} {mode} {skin} minimal {onModeChange} {onSkinChange} />
    <section class="state-panel" aria-live="polite" aria-busy={state === "loading"}>
    {#if state === "loading"}
      <span class="spinner" aria-hidden="true"></span><h2>Checking your workspace</h2>
    {:else if state === "offline"}
      <WifiOff size={18} aria-hidden="true" /><h2>You're offline</h2><p>Meeting Radar needs a connection to show current workspace activity.</p>
      <button class="secondary-action" type="button" onclick={() => onRetry?.()}><RefreshCw size={15} />Retry</button>
    {:else if state === "error"}
      <CircleAlert size={18} aria-hidden="true" /><h2>Unable to connect</h2><p>Meeting Radar could not reach the workspace service.</p>
      <button class="secondary-action" type="button" onclick={() => onRetry?.()}><RefreshCw size={15} />Retry</button>
    {:else if state === "sign-in"}
      <h2>Sign in to your workspace</h2><p>Use your company Google account to view the meeting radar.</p>
      <button class="primary-action" type="button" onclick={() => onSignIn?.()}><span class="google-mark" aria-hidden="true">G</span>Continue with Google</button>
    {:else if state === "unsupported"}
      <h2>Company account required</h2><p>{user?.email ?? "This Google account"} is a personal Google account and cannot access this workspace.</p>
      <button class="secondary-action" type="button" onclick={() => onSignOut?.()}><LogOut size={15} />Sign out</button>
    {:else}
      <h2>Workspace setup needed</h2><p>{canConfigure ? `${user?.name ?? "You"} can connect this workspace to SoWork.` : "A workspace admin needs to connect SoWork before the radar is available."}</p>
      {#if canConfigure}<button class="primary-action" type="button" onclick={() => onConfigure?.()}>Configure workspace</button>{/if}
      <button class="secondary-action" type="button" onclick={() => onSignOut?.()}><LogOut size={15} />Sign out</button>
    {/if}
    {#if state === "sign-in" || state === "unsupported"}
      <nav class="auth-legal-links" aria-label="Legal">
        <a href="/privacy">Privacy Policy</a>
        <span aria-hidden="true">·</span>
        <a href="/terms">Terms of Service</a>
      </nav>
    {/if}
    </section>
  </div>
</main>
